"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BeepFailure = require("../Assets/Audio/beepFailure.mp3");
var BeepSuccess = require("../Assets/Audio/beepSuccess.mp3");
var ScannerBeepService = /** @class */ (function () {
    function ScannerBeepService() {
        this.success = new Audio(BeepSuccess);
        this.failure = new Audio(BeepFailure);
    }
    ScannerBeepService.prototype.Play = function (success) {
        if (success) {
            this.success.play();
        }
        else {
            this.failure.play();
        }
    };
    return ScannerBeepService;
}());
exports.ScannerBeepService = ScannerBeepService;
exports.ScannerBeep = new ScannerBeepService();
//# sourceMappingURL=ScannerBeepService.js.map